module.exports = __webpack_public_path__ + "static/img/shopNameFront.d06ce293.png";